const QUEUE_KEY = 'attendance_offline_queue';
const MAX_QUEUE_ITEMS = 120;

const readQueue = () => {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeQueue = (items) => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(items));
};

const normalizeRequestId = (payload) =>
  String(payload?.request_id || payload?.requestId || '').trim();

const isPermanentFailureMessage = (message) => {
  const text = String(message || '').toLowerCase();
  if (!text) return false;
  return (
    text.includes('mỗi ngày chỉ được chấm công vào 1 lần') ||
    text.includes('mỗi ngày chỉ được chấm công ra 1 lần') ||
    text.includes('cần chấm công vào trước') ||
    text.includes('invalid_employee') ||
    text.includes('missing_business_report') ||
    text.includes('missing_sales_report_fields') ||
    text.includes('auth_required') ||
    text.includes('token_expired') ||
    text.includes('invalid_token') ||
    text.includes('invalid_nonce') ||
    text.includes('khong lay duoc auth token') ||
    text.includes('không lấy được auth token') ||
    text.includes('desktop_blocked') ||
    text.includes('web_attendance_blocked')
  );
};

const isPermanentFailureResult = (result) => {
  if (!result || result.ok !== false) return false;
  if (isPermanentFailureMessage(result.error || '')) return true;
  return isPermanentFailureMessage(result.code || '');
};

const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const dataUrlToFile = (dataUrl, filename = 'offline.jpg') => {
  if (!dataUrl || typeof dataUrl !== 'string') return null;
  const parts = dataUrl.split(',');
  if (parts.length < 2) return null;
  const mimeMatch = parts[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const bytes = atob(parts[1]);
  const arr = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) arr[i] = bytes.charCodeAt(i);
  return new File([arr], filename, { type: mime });
};

export const enqueueAttendance = async (payload, imageFile) => {
  const queue = readQueue();
  const imageDataUrl = imageFile ? await fileToDataUrl(imageFile) : null;
  const requestId = normalizeRequestId(payload);
  const nextItem = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: Date.now(),
    payload,
    imageDataUrl,
    requestId,
  };

  const deduped = requestId ? queue.filter((item) => item.requestId !== requestId) : queue;
  deduped.push(nextItem);
  const bounded = deduped.length > MAX_QUEUE_ITEMS
    ? deduped.slice(deduped.length - MAX_QUEUE_ITEMS)
    : deduped;
  writeQueue(bounded);
};

export const getQueueSize = () => readQueue().length;

export const flushAttendanceQueue = async (submitFn) => {
  const queue = readQueue();
  if (!queue.length) return { sent: 0, failed: 0, dropped: 0 };

  const remain = [];
  let sent = 0;
  let dropped = 0;

  for (const item of queue) {
    try {
      const payload = { ...item.payload };
      if (item.imageDataUrl) {
        payload.image = dataUrlToFile(item.imageDataUrl, `${payload.type || 'attendance'}_${item.createdAt}.jpg`);
      }
      const result = await submitFn(payload);
      if (isPermanentFailureResult(result)) {
        dropped += 1;
        continue;
      }
      if (result && result.ok === false) {
        remain.push(item);
        continue;
      }
      sent += 1;
    } catch (error) {
      if (isPermanentFailureMessage(error?.message || '')) {
        dropped += 1;
      } else {
        remain.push(item);
      }
    }
  }

  writeQueue(remain);
  return { sent, failed: remain.length, dropped };
};
